// extracted by mini-css-extract-plugin
module.exports = {"container":"dece2e673c--container--xUhJI","empty_photo":"dece2e673c--empty_photo--xK1lH","overlay":"dece2e673c--overlay--eUaWU","text":"dece2e673c--text--zViGT"};